import React from "react";
import { MapPin } from "lucide-react";

const areas = {
  "Sandhills (Home Base)": [
    "Southern Pines",
    "Pinehurst",
    "Aberdeen",
    "Cameron",
    "Carthage",
    "Whispering Pines",
    "West End",
    "Vass",
    "Pinebluff",
    "Moore County",
  ],
  "Triangle": [
    "Raleigh",
    "Durham",
    "Cary",
    "Apex",
    "Holly Springs",
    "Chapel Hill",
    "Sanford",
    "Fuquay-Varina",
    "Garner",
    "Wake County",
  ],
  "Triad": [
    "Greensboro",
    "Winston-Salem",
    "High Point",
    "Burlington",
    "Asheboro",
    "Guilford County",
  ],
  "Charlotte Metro": [
    "Charlotte",
    "Concord",
    "Huntersville",
    "Matthews",
    "Mooresville",
    "Mecklenburg County",
  ],
  "Eastern NC & Coast": [
    "Fayetteville",
    "Fort Liberty (Bragg)",
    "Wilmington",
    "Greenville",
    "Rocky Mount",
    "Cumberland County",
  ],
};

export default function ServiceAreas() {
  return (
    <section id="service-areas" className="py-24 lg:py-32 bg-[#eee3cf]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-14">
          <div className="inline-flex items-center gap-2 mb-4">
            <MapPin className="w-5 h-5 text-[#e8a428]" strokeWidth={1.8} />
            <span className="text-xs uppercase tracking-[0.25em] font-semibold text-[#e8a428]">
              Service Areas
            </span>
          </div>
          <h2 className="font-serif text-4xl lg:text-5xl leading-[1.1] text-[#143527] mb-6">
            Facility services across North Carolina.
          </h2>
          <p className="text-[16px] text-[#143527]/75 leading-relaxed">
            Headquartered in Southern Pines, Tidy Clean Up serves businesses, airports, warehouses, offices
            and event venues across the Sandhills, Triangle, Triad, Charlotte metro and Eastern Carolina.
            Don&rsquo;t see your city? Call us &mdash; we travel.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {Object.entries(areas).map(([region, cities]) => (
            <div
              key={region}
              className="bg-[#f4ebde] rounded-3xl p-7 lg:p-8 border border-[#143527]/10"
            >
              <h3 className="font-serif text-2xl text-[#143527] mb-4">{region}</h3>
              <ul className="space-y-2">
                {cities.map((city) => (
                  <li
                    key={city}
                    className="flex items-center gap-2 text-[15px] text-[#143527]/80"
                  >
                    <span className="w-1.5 h-1.5 rounded-full bg-[#e8a428] shrink-0" />
                    <span>{city}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 p-6 lg:p-8 bg-[#143527] rounded-3xl text-[#f4ebde] flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div>
            <p className="font-serif text-2xl lg:text-3xl mb-1">Serving aviation, commercial, industrial &amp; event facilities.</p>
            <p className="text-sm text-[#f4ebde]/70">
              FBOs, executive airports, corporate campuses, warehouses, production floors, venues and more.
            </p>
          </div>
          <a
            href="#quote"
            className="inline-flex items-center gap-2 rounded-full bg-[#e8a428] text-[#143527] px-6 py-3 text-sm font-semibold hover:bg-[#f0b54a] transition-colors whitespace-nowrap"
          >
            Get a quote for your area
          </a>
        </div>
      </div>
    </section>
  );
}
